"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.X = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var X = function (props) {
    var _a;
    return ((0, jsx_runtime_1.jsx)(material_1.SvgIcon, __assign({}, props, { viewBox: "0 0 35 35", children: (0, jsx_runtime_1.jsxs)("svg", { width: "35", height: "35", viewBox: "0 0 35 35", fill: (_a = props.fill) !== null && _a !== void 0 ? _a : 'none', xmlns: "http://www.w3.org/2000/svg", children: [(0, jsx_runtime_1.jsx)("circle", { cx: "17.5", cy: "17.5", r: "17", stroke: "currentColor" }), (0, jsx_runtime_1.jsx)("path", { d: "M18.7877 16.4631L23.8277 10.7305H22.6334L18.2571 15.708L14.7619 10.7305H10.7305L16.016 18.2574L10.7305 24.2689H11.9249L16.5462 19.0125L20.2375 24.2689H24.2689L18.7877 16.4631ZM17.1518 18.3237L16.6163 17.5742L12.3552 11.6102H14.1897L17.6284 16.4234L18.164 17.1729L22.6339 23.4292H20.7994L17.1518 18.3237Z", fill: "currentColor" })] }) })));
};
exports.X = X;
